<style scoped lang="less">
   *{
       margin: 0;
       padding: 0;
   }
   .img1{
       width: 100%;
       height: 100%;
       border: 0;
       margin-top: -1vh;
   }
   .footer{
       height: 40vw;
       background: #FFFFFF;
       img{
           width: 20vw;
       }
   }
   .footer-button{
       background: #333;
       width: 70vw;
       height: 13vw;
       display: flex;
       justify-content: center;
       align-items: center;
       margin: 0 auto;
   }
</style>

<template>
    <div class="container">
        <div style="background: #ffffff">
            <img class="img1" src="../../assets/ad/01.jpg">
            <img class="img1" src="../../assets/ad/02.jpg">
            <img class="img1" src="../../assets/ad/03.jpg">
            <img class="img1" src="../../assets/ad/04.jpg">
            <img class="img1" src="../../assets/ad/05.jpg">
        </div>
        <div class="footer">
            <div class="footer-button" @click="handleClick"><img src="../../assets/ad/buy.png"></div>
        </div>
    </div>
</template>

<script>
// import axios from "axios";
import api from "@/api/ad";
export default {
    name: "DoorTip",
    data(){
        return{
            flag:0,
            userId:''
        }
    },
    async mounted(){
        await this.getUserId();
        // if(this.flag==0){
        //     this.collect(this.flag)
        // }
    },
    methods:{
        getUserId(){
            return api.getUserId({}).then(response => {this.userId=response.data.id})
        },
        handleClick(){
            // this.flag=1;
            // this.collect(this.flag)
            window.location.href="https://item.taobao.com/item.htm?spm=a230r.7195193.1997079397.8.yU5oyp&id=558693037522&abbucket=8";
        },
        // collect(flag){
        //      let data={
        //         "token": "sdf123!@&hsdfa",
        //         "userId": this.userId,
        //         "collect":"lockInApp",
        //         "event": flag==0?"browse":"clickBuy"
        //     };
        //     axios({
        //         method: 'post',
        //         url: 'https://u.robooot.com:3050/api/collect/fromWeb',
        //         headers: {'Content-Type':'application/json'},
        //         data: data
        //         }).then(()=>{
        //             window.location.href="https://item.taobao.com/item.htm?spm=a230r.7195193.1997079397.8.yU5oyp&id=558693037522&abbucket=8";
        //         })
        // }
    }
}
</script>
